import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Routes from './routes'

import SeedCropTable from 'views/pages/SeedCrop/SeedCropTable'
import SeedCropEdit from './SeedCropEdit'
import SeedCropAdd from './SeedCropAdd'

const SeedCropPage = () => {
  return (
    <Switch>
      <Route path={Routes.List} exact={true}>
        <SeedCropTable />
      </Route>
      <Route path={Routes.Edit} exact={true}>
        <SeedCropEdit />
      </Route>
      <Route path={Routes.Add} exact={true}>
        <SeedCropAdd />
      </Route>
      <Redirect to={Routes.List} />
    </Switch>
  )
}

export default SeedCropPage
